/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { RegisterByGroupSchema } from "../types";

export const useRegisterByGroup = ({ group_id, usage }: { group_id: string, usage: string }) => {
  const api = useApi();
  const [data, setData] = useState<RegisterByGroupSchema[]>([]);
  const [isLoading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);
    const params: { [key: string]: number | string | undefined } = {};
    if (group_id) params.group_id = group_id;
    if (usage) params.usage = usage;

    api.get("/assetdepre/get_data_asset", { params })
      .then((res: SuccessFetch<{ payload: RegisterByGroupSchema[] }>) => setData(res.data.payload ?? []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData([]);
      setLoading(false);
    };
  }, [group_id, usage]);

  return {
    data,
    isLoading,
    refetch
  };
}
